import React from 'react'
import { Link } from 'react-router-dom'
import icon1 from '../../images/icon/sms-white.svg'
import icon2 from '../../images/icon/call-white.svg'
import icon3 from '../../images/icon/location.svg'
// removed unused newsletter icon
import Services from '../../api/service'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

// newsletter form removed


const Footer = (props) => {
    return (
        <footer className="footer footer-style-two pt-200 bg_img pos-rel" style={{ backgroundColor: "#0c111d" }}>
            <div className="container">
                <div className="xb-footer pt-120">
                    <div className="footer-info ul_li_between">
                        <div className="info-item ul_li">
                            <div className="xb-item--icon">
                                <span><img src={icon1} alt="" /></span>
                            </div>
                            <div className="xb-item--holder">
                                <p className="xb-item--content">Write to us</p>
                                <h4 className="xb-item--title">support@uniflame.org</h4>
                            </div>
                        </div>
                        <div className="info-item ul_li">
                            <div className="xb-item--icon clr-blue">
                                <span><img src={icon2} alt="" /></span>
                            </div>
                            <div className="xb-item--holder">
                                <p className="xb-item--content">Call Us (IND)</p>
                                <h4 className="xb-item--title">+(91) 7806967605</h4>
                            </div>
                        </div>
                        <div className="info-item ul_li">
                            <div className="xb-item--icon clr-sky">
                                <span><img src={icon3} alt="" /></span>
                            </div>
                            <div className="xb-item--holder">
                                <p className="xb-item--content">Our Office</p>
                                <h4 className="xb-item--title"> Chennai , London </h4>
                            </div>
                        </div>
                    </div>
                    <div className="footer-inner mt-70 mb-100 ul_li_between align-items-start">
                        <div className="sa-newslatter footer-widget">
                            <span className="xb-item--sub-title">Contact Us</span>
                            <p className="xb-item--content clr-white">Questions about Odoo integration, services, or demos? We're here to help — reach out and we'll respond within 24 hours.</p>

                            <div style={{ marginTop: '18px', display: 'flex', gap: '12px', alignItems: 'center' }}>
                                <Link
                                    onClick={ClickHandler}
                                    to="/contact"
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '12px 22px',
                                        backgroundColor: '#ffc107',
                                        color: '#0c111d',
                                        textDecoration: 'none',
                                        borderRadius: '6px',
                                        fontWeight: '700',
                                        fontSize: '15px',
                                        transition: 'all 0.25s ease',
                                        boxShadow: '0 6px 18px rgba(255,193,7,0.18)'
                                    }}
                                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#ffb300'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#ffc107'; e.currentTarget.style.transform = 'translateY(0)'; }}
                                >
                                    <i className="fas fa-envelope" style={{ marginRight: '10px', fontSize: '16px' }}></i>
                                    Contact Us
                                </Link>

                                <a
                                    href="mailto:support@uniflame.org"
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '10px 16px',
                                        backgroundColor: 'transparent',
                                        color: '#ffc107',
                                        textDecoration: 'none',
                                        borderRadius: '6px',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        border: '1px solid rgba(255,193,7,0.18)'
                                    }}
                                >
                                    <i className="fas fa-at" style={{ marginRight: '8px' }}></i>
                                    Email
                                </a>
                            </div>

                            <span className="xb-item--text" style={{ marginTop: '14px', display: 'block', fontSize: '12px', opacity: 0.85 }}>
                                Response time: Within 24 hours
                            </span>
                        </div>
                        <div className="footer-widget">
                            <span className="xb-item--sub-title">Company</span>
                            <ul className="xb-item--holder list-unstyled">
                                <li className="xb-item--list"><Link onClick={ClickHandler} to="/">Home</Link></li>
                                <li className="xb-item--list"><Link onClick={ClickHandler} to="/contact">About us</Link></li>
                              
                                <li className="xb-item--list"><Link onClick={ClickHandler} to="/blog">Our blog</Link></li>
                            <li className="xb-item--list"><Link onClick={ClickHandler} to="/service">  Service</Link></li>
                                <li className="xb-item--list"><Link onClick={ClickHandler} to="/casestudy">Our Cases</Link></li>
                            </ul>
                        </div>
                        <div className="footer-widget">
                            <span className="xb-item--sub-title">Our Services</span>
                            <ul className="xb-item--holder list-unstyled">
                                {Services.slice(0, 6).map((service, srv) => (
                                    <li key={srv} className='xb-item--list'>
                                        {service.title ?
                                            <Link onClick={ClickHandler} to={`/service-single/${service.slug}`}>
                                                <span className="icon_list_text">
                                                    {service.title}
                                                </span>
                                            </Link>
                                            : ''}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="footer-widget">
                            <span className="xb-item--sub-title">Our Industries</span>
                            <ul className="xb-item--holder list-unstyled">
                                <li className="xb-item--list">Retail & E-commerce</li>
                                <li className="xb-item--list">Manufacturing</li>
                                <li className="xb-item--list">Distribution</li>
                                <li className="xb-item--list">Logistics</li>
                                <li className="xb-item--list">SaaS & Technology</li>
                                <li className="xb-item--list">Startups</li>
                            </ul>
                        </div>
                    </div>
                    <div className="footer-copyright mt-70 ul_li_between">
                        <p className="copyright mt-20">Copyright © 2025 <Link onClick={ClickHandler} to="/">Uniflame</Link>. All rights
                            reserved.</p>
                        <ul className="footer-link ul_li mt-20">
                            <li><span>Follow us :</span></li>
                          
                         <li>
  <a 
    onClick={ClickHandler} 
    href="https://www.linkedin.com/company/uniflames/" 
    aria-label="Linkedin"
    target="_blank"
    rel="noopener noreferrer"
  >
    <i className="fab fa-linkedin-in"></i>
  </a>
</li>

                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;
